import {
  HOME_TO_VISIT_POSTCODE_DISTANCE_GET_REQUEST,
  HOME_TO_VISIT_POSTCODE_DISTANCE_GET_SUCCESS,
  HOME_TO_VISIT_POSTCODE_DISTANCE_GET_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';

export function getHomeToVisitPostcodeDistance(treatmentId, assignmentId) {
  return {
    types: [
      HOME_TO_VISIT_POSTCODE_DISTANCE_GET_REQUEST,
      HOME_TO_VISIT_POSTCODE_DISTANCE_GET_SUCCESS,
      HOME_TO_VISIT_POSTCODE_DISTANCE_GET_FAILURE,
    ],
    buildCallParameters: () => ({
      method: HTTP_METHOD.GET,
      path: `v1/query/GetHomeToVisitLocationDistance?TreatmentInstanceId=${treatmentId}&AssignmentId=${assignmentId}`,
    }),
  };
}
